import { IQueryConditionHandler } from "./iquerycondition.handler";

import { CompareType } from '../enum/compare-type.enum';
import { ValueType } from '../enum/value-type.enum';
import { RelationType } from '../enum/relation-type.enum';
import { QueryCondition } from '../../entity/querycondition';
import { RadioGroupValue } from '../../entity/conditionvalue/radiovalue';

export class RadioHandler implements IQueryConditionHandler{
    convert(qc: QueryCondition) {
        const radiov = (qc.value as RadioGroupValue);
        if(radiov.value === undefined || radiov.value === null ||  Object.keys(radiov).length === 0 || Object.keys(radiov.value).length === 0)
            return [];
        return [{
            'FilterField' : qc.fieldCode,
            'Compare' : CompareType.Equal, //equal
            'Value' : radiov.value,
            'Relation' : RelationType.And, //and
            'Expresstype': ValueType.Value
        }];
    }
}